import { episodeOfCareAction } from '../../actions/constant';

const {
    GET_EPISODE_OF_CARE_REQUIRED_DOCUMENT_REQUEST,
    GET_EPISODE_OF_CARE_REQUIRED_DOCUMENT_SUCCESS,
    GET_EPISODE_OF_CARE_REQUIRED_DOCUMENT_FAILURE,
} = episodeOfCareAction;

const intitialstate: object = {
    response: null,
    isError: false,
    loading: false,
};

export const getEpisodeOfCareRequiredDocumentReducer = (state = intitialstate, action: any) => {
    switch (action.type) {
        case GET_EPISODE_OF_CARE_REQUIRED_DOCUMENT_SUCCESS: {
            return {
                ...state,
                isError: false,
                response: action.payload?.data,
                loading: false
            };
        }
        case GET_EPISODE_OF_CARE_REQUIRED_DOCUMENT_FAILURE:
            return {
                ...state,
                isError: true,
                response: null,
                loading: false
            };
        case GET_EPISODE_OF_CARE_REQUIRED_DOCUMENT_REQUEST:
            return {
                ...state,
                loading: true,
                isError: false,
            };
        default:
            return state;
    }
};